import { Injectable, signal, effect } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocationStateService {
  ppuLocationId = signal<number>(this.loadLocationId());

  constructor() {
    effect(() => {
      sessionStorage.setItem('ppuLocationId', JSON.stringify(this.ppuLocationId()));
    });
  }

  private loadLocationId(): number {
    const stored = sessionStorage.getItem('ppuLocationId');
    return stored ? JSON.parse(stored) : 0;
  }

  clearLocationId(): void {
    sessionStorage.removeItem('ppuLocationId');
    this.ppuLocationId.set(0);
  }
}

